import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { CommonService } from '../services/common.service';
import { log } from 'util';


@Component({
  selector: 'app-membership-setup',
  templateUrl: './membership-setup.component.html',
  styleUrls: ['./membership-setup.component.css']
})
export class MembershipSetupComponent implements OnInit {

  @ViewChild('fileInput') fileInput;
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    // This will disable dates starting from tomorrow
  };
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {
    cert_details: []
  };
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  savecertList: any;
  fieldName: string;
  fileList: FileList;
  certId: any;
  fileU: boolean;
  formedata: FormData;
  onlyview: boolean = false;
  showMobileCart: boolean = false;
  headerLabel: string;
  getservicecategories: any;
  getservicelists: any;
  list: any;
  totAmt: number = 0;
  getRetailProducts: any[];
  buyingProducts: any = [];
  search: any = [];
  type: any;
  selectedService: any = [];
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService,
    private _common: CommonService

  ) { }

  covan: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;
  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.loginservice.getservicecategory('', '7', this.currentUser).subscribe(data => {
      this.getservicecategories = data['comp_details'];
    }, error => { alert('Network Error getservicecategory API'); });

    this.getRetailProduct();
    this.covan.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
    // this.loginservice.getserviceList('').subscribe(data => {
    //   this.getservicelists = data['comp_details'];
    // });




    this.model = {
      service_category_id: '0',
      compMonth: 7,
      distype: 'percentage',
      memAmt: 1500,
      memReward: 4,
      memProductReward: 2,
      minReward: 250,
      disAmt: 20,
      memRetailDis: 4,
      service_product: '1',
    };

    this._arout.params.subscribe(p => {
      if (p.view_id) {
        this.onlyview = true;
      }
      if (p.type) {
        this.type = p.type;
      } else {
        this.type = '7'
      }
      if (p.service_offered_id) {
        this.headerLabel = 'Edit';
        this.loginservice.getserviceListWithcategory('', this.currentUser).subscribe(data => {
          this.getservicelists = data['comp_details'];
          setTimeout(() => { this.getserviceoffered(p.service_offered_id); }, 300);
        }, error => { alert('Network Error getserviceListWithcategory API'); });
      } else {
        this.loginservice.getserviceListWithcategory('', this.currentUser).subscribe(data => {
          this.getservicelists = data['comp_details'];
        }, error => { alert('Network Error getserviceListWithcategory API'); });
        this.headerLabel = 'New';
        // this.getserviceoffered('');
      }
    }, error => { alert('Network Error params API'); });
  }


  clear() {
    this.model = {
      ...this.model,
      service_category_id: '0',
      compMonth: 7,
      distype: 'percentage',
      memAmt: 1500,
      memReward: 4,
      memProductReward: 2.5,
      minReward: 250,
      disAmt: 20,
      memRetailDis: 20,
      service_product: 1,

    };
  }
  assign_checkbox(data) {

    data.forEach((obj) => {
      this.getservicelists.forEach((items) => {
        items.service_list.forEach((item) => {
          // item.qutity = 0;
          if (item['service_list_id'] === obj['service_list_id'] && item['service_category_id'] === obj['ori_id']) {
            item.qutity += 1;
            item.checked = true;
          }
        });
      });
    });

  }

  calculate() {

    // if (this.model['totAmt'] > 0 && this.model['distype'] != '' && this.model['disAmt'] > '0') {
    //   if (this.model['distype'] === 'amount') {
    //     this.model['final_price'] = this.model['totAmt'] - this.model['disAmt'];
    //   } else if (this.model['distype'] === 'percentage') {
    //     this.model['final_price'] = this.model['totAmt'] - (this.model['totAmt'] / 100) * this.model['disAmt'];
    //   }
    // } else {
    //   this.model['final_price'] = 0;
    // }

  }

  getserviceoffered(service_offered_id) {
    this.loginservice.getserviceofferedsAddEdit(service_offered_id, this.type, this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            if (service_offered_id) {
              // this.model['service_offered_id'] = data['0']['service_offered_id'];
              this.model['service_category_id'] = data['data']['0']['service_category_id'];
              this.model['offer'] = data['data']['0']['service_category'];
              this.model['memName'] = data['data']['0']['service_category'];
              this.model['compMonth'] = data['data']['0']['compMonth'];
              this.model['memAmt'] = data['data']['0']['memAmt'];
              this.model['memReward'] = data['data']['0']['memReward'];
              this.model['memProductReward'] = data['data']['0']['memProductReward'];
              this.model['minReward'] = data['data']['0']['minReward'];
              this.model['memRetailDis'] = data['data']['0']['memRetailDis'];
              this.model['service_product'] = data['data']['0']['service_product'];
              this.totAmt = this.model['totAmt'] = parseInt(data['data']['0']['totAmt']);
              this.model['distype'] = data['data']['0']['distype'];
              this.model['disAmt'] = data['data']['0']['disAmt'];
              this.assign_checkbox(data['data']);
              this.selectedService = this.getservicelists.flatMap(item =>
                item.service_list.filter(items => items.checked)
              );
            }
            this.showLoader = false;
          } else {
            this.model = [];
            this.showLoader = false;
          }
        },
        error => {
          alert('Network Error getserviceofferedsAddEdit API');
          this.showLoader = false;
        });
  }


  setCat(n) {
    if (n > 0) {
      this.model.service_category_id = n;
    } else {
      this.model.service_category_id = '';
    }
  }

  savediscountoffer() {
    // const checkedItems = this.getservicelists.filter(item => item.checked);
    // const checkedItems = this.getservicelists.filter(item => item.checked);
    let checkedItems = []
    if (this.model['service_product'] == '1') {
      if (this.getservicelists.length > 0) {
        checkedItems = this.getservicelists.flatMap(item =>
          item.service_list.filter(items => items.checked)
        );
      } else {
        alert('Please Add Services In Service & Pricing Module')
        this._flashMessagesService.show('Please Add Services In Service & Pricing Module', { cssClass: 'alert-danger' });
        return false;
      }

    } else {
      checkedItems = this.buyingProducts.filter(items => items.checked)
    }
    if ((this.model['distype'] === '' && (this.model['disAmt'] > '0' && this.model['disAmt'] !== '')) || (this.model['distype'] !== '' && (this.model['disAmt'] <= '0' || this.model['disAmt'] === ''))) {
      this._flashMessagesService.show('Please Fill Discount Type & Amount', { cssClass: 'alert-danger' });
      return false;
    }
    if (checkedItems.length > 0 || this.model.compMonth <= 0) {
      this.showLoader = true;
      if (this.model['service_product'] == '1') {
        this.model['type'] = 7;
      } else {
        this.model['type'] = 7;
      }

      if (this.currentUser['dynamic_membership'] === '1' || this.currentUser['dynamic_membership'] === 1) {
        this.model.distype = '';
        this.model.disAmt = 0;
      }
      // this.model['start_date'] = this.loginservice.Objecttodate(this.model['start_date'].date);
      this.loginservice.saveMembership(this.model, checkedItems, this.currentUser)
        .subscribe(
          data => {
            if (data['status'] === 'success') {
              this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
              this.showLoader = false;
              this.router.navigate(['/membership']);
            } else {
              this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
              this.showLoader = false;
            }
          },
          error => {
            alert('Network Error saveMembership API');
          });
    } else {
      this._flashMessagesService.show('Please Select Services', { cssClass: 'alert-danger' });
    }
  }

  chekspackAll(event: Event) {



    this.getservicelists.forEach(element => {
      if ((event.target as HTMLInputElement).checked) {
        this.chekspack(element, false);
      } else {
        this.chekspack(element, true);
      }

      // return false;
    });
  }

  chekspack(items, trufal) {
    if (trufal == true) {
      items.checked = true;
    } else {
      items.checked = false;
    }
    if (items.checked) {
      const NormalCategory = items.service_list.filter(item => !item.checked);
      if (NormalCategory.length > 0) {
        items.service_list.forEach((element, index) => {
          if (!element.checked) {
            this.getprice(element, '+')
          }
          element.checked = false;
        });
      }
      items.service_list.forEach((element, index) => {
        this.getprice(element, '-')
        element.checked = false;
      });
    } else {
      const NormalCategory = items.service_list.filter(item => item.checked);
      if (NormalCategory.length > 0) {
        items.service_list.forEach((element, index) => {
          if (element.checked) {
            this.getprice(element, '-')
          }
          element.checked = false;
        });
      }
      items.service_list.forEach((element, index) => {
        element.checked = true;
        this.getprice(element, '+')
      });
    }
    if (trufal == true) {
      items.checked = false;
    } else {
      items.checked = true;
    }
  }


  chekspackProAll(event: Event) {
    this.getRetailProducts.forEach(element => {
      this.chekspackPro(element, event)
      // this.chekspack(element);
    });
  }


  chekspackPro(covenant, event: Event) {
    if ((event.target as HTMLInputElement).checked) {

      covenant.service.forEach(element => {
        const NormalCategory = element.list.filter(item => item.checked);
        if (NormalCategory.length > 0) {
          element.list.forEach((element, index) => {
            if (element.checked) {
              this.getprice1(element, '-')
            }
            element.checked = false;
          });
        }
        element.list.forEach((element, index) => {
          element.checked = true;
          this.getprice1(element, '+')
        });
      });
    } else {
      covenant.service.forEach(element => {
        const NormalCategory = element.list.filter(item => !item.checked);
        if (NormalCategory.length > 0) {
          element.list.forEach((element, index) => {
            if (!element.checked) {
              this.getprice1(element, '+')
            }
            element.checked = false;
          });
        }
        element.list.forEach((element, index) => {
          this.getprice1(element, '-')
          element.checked = false;
        });
      });
    }

  }

  checkPrice1(item) {
    // this.totAmt = 0;
    // this.model['totAmt'] = 0;
    // this.model['distype'] = '';
    // this.model['disAmt'] = 0;
    // this.model['final_price'] = 0;
    if (item.checked) {
      this.getprice1(item, '-')
    } else {
      this.getprice1(item, '+')
    }
  }

  checkPrice(item) {


    // this.totAmt = 0;
    // this.model['totAmt'] = 0;
    // this.model['distype'] = '';
    // this.model['disAmt'] = 0;
    // this.model['final_price'] = 0;
    if (item.checked) {
      item.qutity = 0;
      this.getprice(item, '-')
      this.selectedService = this.selectedService.filter(offer => offer.id !== item.id);
    } else {
      this.selectedService.push(item)
      this.getprice(item, '+')
    }
  }

  getprice1(item: any, operator: string) {
    this.loginservice.checkPrice1(item, this.currentUser)
      .subscribe(
        (data: any) => {
          let value: any = data;
          if (operator === '+') {
            // Assuming data is a string representing a numeric value
            this.totAmt += parseInt(value);
          } else {
            // Handle other cases if needed
            this.totAmt -= parseInt(value);
          }
          this.model['totAmt'] = this.totAmt;
          this.calculate();
          if (item.checked) {
            this.buyingProducts.push(item);
          } else {
            if (this.buyingProducts.length > 0) {
              const existingIndex = this.buyingProducts.findIndex(elem => elem.id === item.id);
              if (existingIndex !== -1) {
                this.buyingProducts.splice(existingIndex, 1);
              }
            }
          }
        },
        (error: any) => {
          // Handle error if necessary
          alert('Network Error checkPrice1 API');
        }
      );
  }


  getprice(item: any, operator: string) {
    this.loginservice.checkPriceNew(item, this.currentUser)
      .subscribe(
        (data: any) => {
          let value: any = data;
          if (operator === '+') {
            // Assuming data is a string representing a numeric value
            this.totAmt += parseInt(value);
          } else {
            // Handle other cases if needed
            this.totAmt -= parseInt(value);
          }
          this.model['totAmt'] = this.totAmt;
          this.calculate();
        },
        (error: any) => {
          // Handle error if necessary
          alert('Network Error checkPriceNew API');
        }
      );
  }


  onDateChanged(type, event: IMyDateModel): void {
    // date selected
    if (type === 'month') {
      this.model['getmonth'] = event;

    } else {
      this.model['getyear'] = event;
    }
  }


  getRetailProduct() {
    this.loginservice.getRetailProduct(this.search, this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            this.getRetailProducts = data['data'];
            this.getRetailProducts.forEach((covenant: any) => {
              if (covenant.service) {
                covenant.service.forEach((item: any) => {
                  if (item.list) {
                    item.list.forEach((product: any) => {
                      product.checked = false; // Initialize 'checked' property
                      if (this.buyingProducts.length > 0) {
                        this.buyingProducts.forEach(element => {
                          if (element.id == product.id) {
                            product.checked = true;
                          }
                        });
                      }

                    });
                  }
                });
              }
            });
          } else {
            this.getRetailProducts = [];
          }
        }, error => { alert('Network Error getRetailProduct API'); });
  }


  addMinus(addMinus, item) {
    if (item.checked) {
      if (addMinus === '1') {
        if (parseInt(item.qutity) <= 0) {
          item.qutity = 1
        } else {
          item.qutity = parseInt(item.qutity) + 1
        }
      } else {
        if (item.qutity > 0) {
          item.qutity = parseInt(item.qutity) - 1
        }
      }
    }
  }

  animateClick(event: any) {
    event.target.classList.add('clicked-bounce');
    setTimeout(() => {
      event.target.classList.remove('clicked-bounce');
    }, 300);
  }

}



// WEBPACK FOOTER //
// ./src/app/membership-setup/membership-setup.component.ts